<template>
    <div class="IntervalIOListWebinPeriod">
        <v-data-table dense 
        :disable-sort="true" 
        :headers="headers" 
        :items="list" 
        :item-class="row_classes"
        item-key="MessageId" hide-default-footer disable-pagination />
    </div>
</template>
  
<script>
export default {
    props: {
        list: Array,
    },
    methods: {
        row_classes(item) {
            debugger
            if (item.Io_Type == 'ورود') {
                return "bg-green"; //can also return multiple classes e.g ["orange","disabled"]
            }
        },
    },
    data() {
        return {
            headers: [
                {
                    text: this.$t("day"),
                    value: "DayName",
                },
                {
                    text: this.$t("date"),
                    value: "ClockDate",
                },
                {
                    text: this.$t("time"),
                    value: "ClockTime",
                },

                {
                    text: this.$t("io"),
                    value: "Io_Type",
                },

            ],
        };
    },
};
</script>
  
<style>
.bg-green {
    background-color: var(--background-green);
}
</style>